import { useTranslation } from 'react-i18next'
import React from 'react'

import { SmallText } from '../presentation/Text'
import { useStepsActions, useStepsState } from '@btime/react-contexts'
import FlexGrid, { FlexCol } from '../structure/FlexGrid'
import IconButton from '../actions/IconButton'
import Link from '../actions/Link'
import { COLORS } from '@btime/constants'

const StepButtons = ({ color }) => {
  const { t } = useTranslation('components')
  const { canSubmit, isFirst, isLast, loading } = useStepsState()
  const { goToNext, goToPrevious, handleSubmit } = useStepsActions()

  const commonSubmitProps = { color: color || COLORS.purple }
  return (
    <FlexGrid justify="space-between" gutter={0.5}>
      <FlexCol flex={1}>
        {!isFirst && (
          <Link onClick={goToPrevious}>
            <SmallText color={color}>{t('back')}</SmallText>
          </Link>
        )}
      </FlexCol>

      {!isLast && (
        <FlexCol>
          <IconButton
            label={t('next')}
            iconRight="BsArrowRightShort"
            onClick={goToNext}
            {...commonSubmitProps}
            transparent
          />
        </FlexCol>
      )}

      {(canSubmit || isLast) && (
        <FlexCol>
          <IconButton
            label={t('save')}
            iconRight="BsCheck"
            onClick={handleSubmit}
            loading={loading}
            {...commonSubmitProps}
          />
        </FlexCol>
      )}
    </FlexGrid>
  )
}

export default StepButtons
